<template>
    <div class="Controls">
        {{itemData.cnFieldCaption}}
    </div>
</template>

<script>
export default {
  name: 'Controls',
  props: {
    itemData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    type: {
        type: String,
        default: 'otNew'
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
    if (this.type == 'otNew' && this.itemData.inDefaultValue != '') {
      this.updates(this.itemData.inDefaultValue)
    }
  },
  methods: {
    updates(value) {
    },
    submit() {
      return {}
    }
  },
  watch: {
  },
  components: {
  }
}
</script>
